import { cn } from '@synthec/ui'

/**
 * Synthec logo. Isotipo = two sheared parallelograms (Orange Pro #FF8200)
 * forming an "S"; wordmark "synthec" lowercase (Innovation Blue, or inherits
 * `color` when set via `wordmarkClassName`, e.g. white on dark backgrounds).
 * Per the brand manual the isotipo stays orange on every background.
 */
export function Logo({
  className,
  isotipoOnly = false,
  wordmarkClassName = 'text-brand',
}: {
  className?: string
  isotipoOnly?: boolean
  wordmarkClassName?: string
}) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)} aria-label="Synthec">
      <svg
        viewBox="0 0 60 64"
        className="h-[1.1em] w-auto flex-none"
        role="img"
        aria-hidden="true"
        fill="#FF8200"
      >
        <path d="M30 2 L58 2 L36 30 L8 30 Z" />
        <path d="M22 34 L50 34 L28 62 L0 62 Z" />
      </svg>
      {!isotipoOnly && (
        <span
          className={cn(
            'font-display text-[1.15em] font-extrabold lowercase leading-none tracking-[-0.03em]',
            wordmarkClassName,
          )}
        >
          synthec
        </span>
      )}
    </span>
  )
}
